import { Pipe, PipeTransform } from '@angular/core';
import { ConfigProvider } from '../../providers/config/config';

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */

  //EX:
  //{{1234567 | money:'R$',2,' ','.',3}}
  // R$12 345.67
  constructor(public configProvider: ConfigProvider) {}

  transform(
    value: number,
    decimalLength: number = 2,
    chunkDelimiter: string = '.',
    decimalDelimiter: string = ',',
    chunkLength: number = 3,
  ) {
    return this.configProvider.getCurrencySymbol().then((h) => {

      if (value && typeof value !== 'number') {
        value = parseInt(value);
      }

      if (h.currency == 'CLP') {
        decimalLength = 0;
        chunkDelimiter = '.';
        decimalDelimiter = '';
        chunkLength = 3;

        let result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
        let num = value.toFixed(Math.max(0, ~~decimalLength));
        return (
          h.currency +
          ' ' +
          (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(
            new RegExp(result, 'g'),
            '$&' + chunkDelimiter,
          )
        );
      } else {
        value /= 100;

        let result = '\\d(?=(\\d{' + chunkLength + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
        let num = value.toFixed(Math.max(0, ~~decimalLength));
        return (
          h.currency +
          ' ' +
          (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(
            new RegExp(result, 'g'),
            '$&' + chunkDelimiter,
          )
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/money/money.ts